import React from 'react';
import { MenuItemLink, useResourceDefinitions } from 'react-admin';
import { Box, Tooltip } from '@mui/material';
import {
  Dashboard as DashboardIcon,
  SupervisorAccount as AdminIcon,
  People as CustomersIcon,
  FitnessCenter as ProgramsIcon,
  ShoppingCart as ProductsIcon,
  SelfImprovement as ExercisesIcon,
  Campaign as AdvertisementsIcon,
  Quiz as QuestionsIcon,
  EmojiEvents as AchievementsIcon,
  PermMedia as MediaIcon,
  PlayCircleOutline as SessionsIcon,
} from '@mui/icons-material';

const iconMap = {
  dashboard: DashboardIcon,
  admins: AdminIcon,
  customers: CustomersIcon,
  programs: ProgramsIcon,
  products: ProductsIcon,
  exercises: ExercisesIcon,
  advertisements: AdvertisementsIcon,
  questions: QuestionsIcon,
  achievements: AchievementsIcon,
  media: MediaIcon,
  sessions: SessionsIcon,
};

const AppMenu = () => {
  const resourceDefinitions = useResourceDefinitions();
  const resources = Object.keys(resourceDefinitions).map((name) => ({
    name,
    options: resourceDefinitions[name].options || {},
  }));

  const getIcon = (label) => {
    const key = label.toLowerCase();
    const Icon = iconMap[key];
    return Icon ? <Icon /> : <DashboardIcon />;
  };

  return (
    <Box sx={{ width: '100%', paddingTop: '16px' }}>
      <Tooltip title="Dashboard" placement="right">
        <MenuItemLink to="/" primaryText="" leftIcon={<DashboardIcon />} />
      </Tooltip>
      {resources.map((resource) => {
        if (!resource.options.label) {
          return null;
        }
        const { label } = resource.options;
        return (
          <Tooltip key={resource.name} title={label} placement="right">
            <MenuItemLink to={`/${resource.name}`} primaryText="" leftIcon={getIcon(label)} />
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default AppMenu;
